module.exports = __webpack_public_path__ + "static/media/we-right-bottom.29fc2c06.png";